export const shardCountOptions = [
  {
    id: 'shard-count-5',
    label: 'Less than 125M (5 shards)',
    value: 5,
  },
  {
    id: 'shard-count-20',
    label: '125M to 500M (20 shards)',
    value: 20,
  },
  {
    id: 'shard-count-50',
    label: '500M to 1.25B (50 shards)',
    value: 50,
  },
  {
    id: 'shard-count-100',
    label: '1.25B to 2.5B (100 shards)',
    value: 100,
  },
  {
    id: 'shard-count-200',
    label: '2.5B to 5B (200 shards)',
    value: 200,
  },
  {
    id: 'shard-count-400',
    label: 'More than 5B (400 shards)',
    value: 400,
  },
];
